export const Base64ImageType = {JPG: 'jpg', PNG: 'png', JPEG: 'jpeg'} as const;
export type Base64ImageType = (typeof Base64ImageType)[keyof typeof Base64ImageType];
